export const TOKEN = 'token';
export const INV_TOKEN = 'invitationToken';
export const BEARER_TOKEN = 'bearer_token';
export const AUTHORIZATION_HEADER = 'authorization';
export const ADMIN = 'admin';
export const DOMAIN_PREFIX = 'auth';
